import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from 'shared/components/ui/confirm-dialog';

export type DiscardChangesDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DiscardChangesDialog: React.FC<DiscardChangesDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      title={t('dialogs.task-detail.discard-changes.title')}
      message={t('dialogs.task-detail.discard-changes.body')}
      confirmLabel={t('dialogs.task-detail.discard-changes.discard')}
      cancelLabel={t('dialogs.task-detail.discard-changes.cancel')}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
};
